import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps): JSX.Element {
  const { user, isAdminUser, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: "100px 20px", textAlign: "center" }}>Loading...</div>;
  }

  if (!user || !isAdminUser) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}
